import { money } from "../../lib/api";
import { useAdminList, AdminHead } from "./adminUi";

const Stat = ({ label, value, testid }) => (
  <div className="rounded-3xl bg-white p-6 shadow-sm" data-testid={testid}>
    <p className="text-xs font-bold uppercase tracking-wider text-navy/50">{label}</p>
    <p className="mt-2 text-3xl font-extrabold text-navy">{value}</p>
  </div>
);

const RankList = ({ title, rows, render, empty }) => (
  <div className="rounded-3xl bg-white p-6 shadow-sm">
    <h3 className="font-bold text-navy">{title}</h3>
    {rows.length ? <ol className="mt-4 space-y-2 text-sm">{rows.map(render)}</ol> : <p className="mt-4 text-sm text-navy/50">{empty}</p>}
  </div>
);

export default function AdminOverview() {
  const { data: a } = useAdminList("/admin/analytics");
  if (!a) return <div className="h-64 rounded-3xl bg-white animate-pulse" />;
  const max = Math.max(...a.revenue_trend.map((d) => d.revenue), 1);
  return (
    <div data-testid="admin-overview">
      <AdminHead title="Overview" sub="All figures come from real paid orders in your database — no sample data." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Total sales" value={money(a.total_sales)} testid="stat-total-sales" />
        <Stat label="Paid orders" value={a.orders} testid="stat-orders" />
        <Stat label="Avg. order value" value={money(a.average_order_value)} testid="stat-aov" />
        <Stat label="Subscribers" value={a.subscribers} testid="stat-subscribers" />
      </div>
      <div className="mt-6 rounded-3xl bg-white p-6 shadow-sm" data-testid="revenue-trend">
        <h3 className="font-bold text-navy">Revenue · last 30 days</h3>
        <div className="mt-6 h-40 flex items-end gap-1">
          {a.revenue_trend.map((d) => (
            <div key={d.date} title={`${d.date}: ${money(d.revenue)}`} className="flex-1 rounded-t bg-turq/80 hover:bg-tpink transition-colors" style={{ height: `${Math.max((d.revenue / max) * 100, 2)}%` }} />
          ))}
        </div>
        {a.orders === 0 && <p className="mt-3 text-sm text-navy/50">No paid orders yet — the chart fills in as real sales come in.</p>}
      </div>
      <div className="mt-6 grid lg:grid-cols-2 gap-4">
        <RankList title="Best-selling products" rows={a.best_sellers} empty="No sales yet." render={(p, i) => (
          <li key={p.slug} className="flex justify-between"><span>{i + 1}. {p.name}</span><span className="font-semibold">{p.units} sold · {money(p.revenue)}</span></li>
        )} />
        <RankList title="Popular destinations" rows={a.popular_destinations} empty="No destination sales yet." render={(d, i) => (
          <li key={d.slug} className="flex justify-between"><span>{i + 1}. {d.slug}</span><span className="font-semibold">{d.units} units</span></li>
        )} />
      </div>
      <p className="mt-6 text-sm text-navy/50">Refunded/cancelled orders: {a.refunded_orders} · New contact messages: {a.messages}</p>
    </div>
  );
}
